import * as types from '../actions/types'

const formatHash = hash => hash && hash.replace(/\W/g, '')

const formatRemainingTime = (value) => {
  if (!value || value < 11) {
    return {}
  }
  const secs = value - 1
  const days = (secs / 3600 > 24) ? Math.floor(secs / 3600 / 24) : 0
  let hours = Math.floor((secs / 3600) % 24)
  let minutes = Math.floor((secs / 60) % 60)
  let seconds = secs % 60
  if (hours < 10) {
    hours = `0${hours}`
  }
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return {
    remainingTime: `${hours}:${minutes}:${seconds}`,
    daysLeft: `${days} dias`,
    remainingTimeInSeconds: secs,
    rawValue: secs,
  }
}

const updateLoads = (state) => {
  if (!state) {
    return {}
  }
  let newState = {}
  Object.entries(state).forEach(([key, value]) => {
    newState = {
      ...newState,
      [key]: {
        ...value,
        ...formatRemainingTime(value.rawValue),
      },
    }
  })
  return newState
}

const initialState = null

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CENTRIFUGE_UPDATE_AUCTION_TIME: {
      return {
        ...state,
        [formatHash(payload.loadId)]: {
          remainingTime: payload.remainingTime,
          daysLeft: payload.daysLeft,
          remainingTimeInSeconds: payload.rawValue,
          rawValue: payload.rawValue,
        },
      }
    }
    case types.TICK_AUCTION_TIMER: {
      return state ? {
        ...updateLoads(state),
      } : state
    }
    default:
      return state
  }
}
